import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/ArrowDownward';

class ArrowDownwardIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default ArrowDownwardIcon;
